module.exports = __webpack_public_path__ + "img/vipImg.c8b7f99d.png";